import * as React from "react";
import { BaseComponent } from "../../../react-core/Html/BaseComponent";
import * as classNames from "classNames";
import { AddLogoAction } from "../../Dashboard/Components/Settings/AddLogo/Action/AddLogoAction";
import { FirmLogoStore } from "../../Dashboard/Stroes/Variable";
import { CompanyLogo } from "../../../Wrap/Models/Domains/Company/CompanyLogo";
import { UIThemeAction } from "../../Dashboard/Components/Settings/Action/UIThemeAction";
import { UserStore } from "../../Dashboard/Stroes/Variable";
import { UserClient } from "../../../Wrap/Api/User/User";
import { ActionType } from "../../../react-core/Flux/ActionType";
import { UserDispatcher } from "../../Dashboard/Stroes/Variable";

export interface IAppLogoProps extends React.Props<AppLogo> {
    cssWrapper?: any;
    link?: string;
}

export interface IAppLogoState {
    logoUrl: CompanyLogo;
    loadingLogo: boolean;
}

export class AppLogo extends BaseComponent<IAppLogoProps, IAppLogoState> {
    constructor(props: any) {
        super(props);
        this.state = { logoUrl: null, loadingLogo: true };
        this.subscribeToStore(FirmLogoStore, () => this.onFirmLogoStoreChange());
    }

    componentDidMount() {
        const maybeUser = UserStore.getUserInfo();

        if (!maybeUser) {
            if (UserStore.getUserInfo() || UserStore.isLoading()) {
                return;
            }
            const client = new UserClient();
            const promise = client.get();

            promise.onSuccess((result) => {
                UserDispatcher.dispatch({
                    actionType: ActionType.Success,
                    payload: result,
                });
                this.getFirmLogo();
            });

            promise.onError((err) => {});
        } else {
            this.getFirmLogo();
        }
    }

    private getFirmLogo() {
        const data = FirmLogoStore.getFirmLogoInfo();
        const isAdmin = UserStore.getUserInfo()?.IsAdmin != null ? UserStore.getUserInfo().IsAdmin : true;
        if (!data) {
            AddLogoAction.getLogo(isAdmin);
        } else {
            this.setState({ logoUrl: data, loadingLogo: false });
        }
    }

    private onFirmLogoStoreChange() {
        const data = FirmLogoStore.getFirmLogoInfo();
        this.setState({ logoUrl: data, loadingLogo: false });
    }

    render() {
        const styleObj = UIThemeAction.getLogoUrl(this.state.logoUrl);
        const CSSClasses = classNames("app-logo", this.props.cssWrapper);
        if (!this.state.loadingLogo) {
            return <a className={CSSClasses} style={styleObj} href={this.props.link ? this.props.link : null} />;
        }
        return null;
    }
}
